// extracted by mini-css-extract-plugin
export var container = "_5l-0";
export var infoButton = "_5l-1";
export var label = "_5l-3";
export var labelExpanded = "_5l-4";
export var price = "_5l-5";
export var priceExpanded = "_5l-6";
export var title = "_5l-2";